import queryString from 'query-string';

export interface ResponseError extends Error {
  status?: number;
}
export interface ApiResponse<T> {
  data: T;
  status: number;
  error: string | null;
}

export type apiFetcherArgs = {
  url: string;
  queryParams?: Record<string, string | number | null>;
  options?: RequestInit;
};

export class ApiError extends Error {
  status: number;
  info: unknown;

  constructor(message: string, status: number, info?: unknown) {
    super(message);

    this.name = 'ApiError';
    this.status = status;
    this.info = info;
  }
}

export default async function apiFetcher<T>({
  url,
  queryParams,
  options
}: apiFetcherArgs): Promise<T> {
  let qs: string = '';
  if (queryParams) {
    qs = queryString.stringify(queryParams, {
      skipNull: true,
      skipEmptyString: true
    });
    if (qs) {
      qs = `?${qs}`;
    }
  }

  const res = await fetch(
    // @ts-ignore
    `${import.meta.env.VITE_API_ENDPOINT}${url}${qs}`,
    options
  );

  let body: ApiResponse<T>;

  try {
    body = await res.json();
  } catch {
    throw new ApiError('Invalid JSON response', res.status);
  }

  if (!res.ok || body.error) {
    throw new ApiError(
      body.error || 'API request failed',
      body.status || res.status,
      body
    );
  }

  return body.data;
}
